import { IconButton, Tooltip } from '@mui/material';
import { Info } from '@vy/ui-design-system';
import type { DisconnectedMeter } from '@vy/types';

type Props = {
  disconnectedMeters: DisconnectedMeter[];
  open: boolean;
  onToggle: () => void;
};

export function DisconnectedMeterWarningsToggle({ disconnectedMeters, open, onToggle }: Props) {
  return (
    <Tooltip title={open ? 'Hide disconnected meters' : 'Show disconnected meters'} placement="top">
      <IconButton
        size="small"
        onClick={onToggle}
        sx={{ color: open ? 'warning.main' : 'text.secondary', ml: 0.5 }}
      >
        <Info width={18} height={18} viewBox="0 0 24 24" />
      </IconButton>
    </Tooltip>
  );
}
